import React from 'react';
import { EditableColumnType } from 'components/CustomTable/CustomTable';
import CustomSelect from 'components/CustomSelect';
import { DataType } from 'store/ducks/DataEntry/Branch/types';
import { Button, DatePicker } from 'antd';
import dayjs from 'dayjs';
import * as Styled from '../Tables/DataEntry/DataEntry.styled';
import { IResponsibilitiesTypes } from 'store/ducks/DataManagement/Article8AndICTSystem/types';

export const getResponsibilities = (
  handleDateChange: (key: number, field: string, value: string) => void,
  handleSave: (record: IResponsibilitiesTypes) => void,
  handleAddRow: (record: { key: React.Key }, index: number) => void,
  handleRemoveRow: (key: number) => void,
  handleInactivate: (record: IResponsibilitiesTypes) => void,
  roles: { value: string; label: string }[],
  t: any,
): EditableColumnType[] => [
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('RESPONSIBILITIES.NAME')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'name',
    editable: true,
    fixed: 'left',
  },
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('RESPONSIBILITIES.ROLE')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'dependency_type_id',
    editable: false,
    render: (_, record) => (
      <CustomSelect
        options={roles}
        value={record.role_id}
        onChange={(value: any) =>
          handleSave({
            ...record,
            role_id: value,
          } as IResponsibilitiesTypes)
        }
        filterOption={(input: string, option: { label: string }) =>
          option?.label?.toLowerCase().includes(input.toLowerCase())
        }
      />
    ),
  },
  {
    title: <>{t('RESPONSIBILITIES.RESPONSIBILITY_VALIDITY')}</>,
    dataIndex: 'date_range',
    editable: false,
    render: (_: any, record: DataType) => {
      return (
        <Styled.DateInputs>
          <DatePicker
            value={record.start_date ? dayjs(record.start_date) : null}
            format="YYYY-MM-DD"
            onClick={(e) => e.stopPropagation()}
            onChange={(date) => {
              const formattedDateString = date
                ? dayjs(date).format('YYYY-MM-DD')
                : '1900-01-01';

              handleDateChange(record.key, 'start_date', formattedDateString);
            }}
          />
          <DatePicker
            value={record.end_date ? dayjs(record.end_date) : null}
            format="YYYY-MM-DD"
            onClick={(e) => e.stopPropagation()}
            onChange={(date) => {
              const formattedDateString = date
                ? dayjs(date).format('YYYY-MM-DD')
                : '9999-01-01';

              handleDateChange(record.key, 'end_date', formattedDateString);
            }}
          />
        </Styled.DateInputs>
      );
    },
  },
  {
    title: (
      <Styled.TitleComponent>
        <div>
          <p>{t('RESPONSIBILITIES.DESCRIPTION')}</p>
        </div>
      </Styled.TitleComponent>
    ),
    dataIndex: 'description',
    editable: true,
  },
  {
    title: t('GENERAL.ACTIONS'),
    key: 'actions',
    width: 150,
    render: (_: any, record) => (
      <>
        {record.isNew ? (
          <Button danger onClick={() => handleRemoveRow(record.key)}>
            {t('GENERAL.REMOVE')}
          </Button>
        ) : (
          <Button
            danger
            onClick={() => handleInactivate(record as IResponsibilitiesTypes)}
          >
            {t('GENERAL.SOFT_DELETE')}
          </Button>
        )}
      </>
    ),
  },
];
